module.exports = __webpack_public_path__ + "static/media/foodshot12.90649901.JPG";